module.exports = __webpack_public_path__ + "static/media/siddharth-coorg-trip.7eaae893.jpg";